var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptySmg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_641_5048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.3927 34.6798C59.2803 34.6798 60 33.9602 60 33.0725V14.8863C60 13.9986 59.2803 13.2789 58.3927 13.2789H13.053C12.1654 13.2789 11.4457 13.9986 11.4457 14.8863V47.2734C11.4457 49.511 9.62513 51.3318 7.3873 51.3318H7.27286C5.03524 51.3316 3.21466 49.511 3.21466 47.2734V8.66974H49.3352C50.2229 8.66974 50.9426 7.95009 50.9426 7.06241C50.9426 6.17473 50.2229 5.45508 49.3352 5.45508H1.60733C0.719656 5.45508 0 6.17473 0 7.06241V47.2734C0 51.2838 3.26267 54.5464 7.27307 54.5464H7.38751H50.5065C55.7412 54.5464 60.0002 50.2874 60.0002 45.0527C60.0002 44.165 59.2806 43.4453 58.3929 43.4453C57.5052 43.4453 56.7855 44.165 56.7855 45.0527C56.7855 48.5151 53.9686 51.3318 50.5065 51.3318H13.4199C14.2028 50.1719 14.6604 48.775 14.6604 47.2734V16.4936H56.7853V33.0725C56.7853 33.9602 57.505 34.6798 58.3927 34.6798Z",
    fill: "#6E8877"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_5048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySmg);
export default __webpack_public_path__ + "static/media/empty-smg.802cbcee50f42b96fba63b7a6fb7ccaf.svg";
export { ForwardRef as ReactComponent };